'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _numbro = require('numbro');

var _numbro2 = _interopRequireDefault(_numbro);

var _fitnessLeaderboard = require('../../api/fitness-leaderboard');

var _icon = require('constructicon/icon');

var _icon2 = _interopRequireDefault(_icon);

var _loading = require('constructicon/loading');

var _loading2 = _interopRequireDefault(_loading);

var _metric = require('constructicon/metric');

var _metric2 = _interopRequireDefault(_metric);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TotalElevation = function (_Component) {
  _inherits(TotalElevation, _Component);

  function TotalElevation() {
    _classCallCheck(this, TotalElevation);

    var _this = _possibleConstructorReturn(this, (TotalElevation.__proto__ || Object.getPrototypeOf(TotalElevation)).call(this));

    _this.fetchData = _this.fetchData.bind(_this);
    _this.state = { status: 'fetching' };
    return _this;
  }

  _createClass(TotalElevation, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var refreshInterval = this.props.refreshInterval;

      this.fetchData();
      this.interval = refreshInterval && setInterval(this.fetchData, refreshInterval);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearInterval(this.interval);
    }
  }, {
    key: 'fetchData',
    value: function fetchData() {
      var _this2 = this;

      var _props = this.props,
          activity = _props.activity,
          campaign = _props.campaign,
          includeManual = _props.includeManual;


      (0, _fitnessLeaderboard.fetchFitnessLeaderboard)({
        activity: activity,
        campaign: campaign,
        include_manual: includeManual,
        limit: 9999,
        sortBy: 'elevation'
      }).then(function (data) {
        return _this2.setState({
          data: _this2.calculateTotal(data),
          status: 'fetched'
        });
      }).catch(function (error) {
        _this2.setState({ status: 'failed' });
        return Promise.reject(error);
      });
    }
  }, {
    key: 'calculateTotal',
    value: function calculateTotal(data) {
      return data.reduce(function (total, item) {
        return total + item.elevation_in_meters;
      }, 0);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          icon = _props2.icon,
          label = _props2.label,
          metric = _props2.metric;


      return _react2.default.createElement(_metric2.default, _extends({
        icon: icon,
        label: label,
        amount: this.renderAmount()
      }, metric));
    }
  }, {
    key: 'renderAmount',
    value: function renderAmount() {
      var _state = this.state,
          status = _state.status,
          data = _state.data;
      var _props3 = this.props,
          format = _props3.format,
          offset = _props3.offset,
          multiplier = _props3.multiplier,
          suffix = _props3.suffix;


      switch (status) {
        case 'fetching':
          return _react2.default.createElement(_loading2.default, null);
        case 'failed':
          return _react2.default.createElement(_icon2.default, { name: 'warning' });
        default:
          return '' + (0, _numbro2.default)((offset + data) * multiplier).format(format) + suffix;
      }
    }
  }]);

  return TotalElevation;
}(_react.Component);

TotalElevation.propTypes = {
  /**
   * The campaign uid/s to fetch totals for
   */
  campaign: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.array]),

  /**
   * The type of activity to get kms for
   * e.g. bike, [bike, run, walk, swim]
   */
  activity: _propTypes2.default.oneOf([_propTypes2.default.string, _propTypes2.default.array]),

  /**
   * Include manual fitness activities
   */
  includeManual: _propTypes2.default.bool,

  /**
   * Offset
   */
  offset: _propTypes2.default.number,

  /**
   * The amount to multiply the total by for custom conversions
   */
  multiplier: _propTypes2.default.number,

  /**
   * The format of the number
   */
  format: _propTypes2.default.string,

  /**
   * The label of the metric
   */
  label: _propTypes2.default.string,

  /**
   * The suffix to display
   */
  suffix: _propTypes2.default.string,

  /**
   * The icon to use
   * - String representing a constructicon icon e.g. heart
   * - Array of custom paths
   * - An element to use instead e.g. <i className='fa fa-heart' />
   */
  icon: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.array, _propTypes2.default.element]),

  /**
   * Props to be passed to the Constructicon Metric component
   */
  metric: _propTypes2.default.object,

  /**
   * Interval (in milliseconds) to refresh data from API
   */
  refreshInterval: _propTypes2.default.number
};

TotalElevation.defaultProps = {
  label: 'Total Elevation',
  offset: 0,
  multiplier: 1,
  format: '0,0',
  suffix: 'm'
};

exports.default = TotalElevation;


//////////////////
// WEBPACK FOOTER
// ../~/supporticon/components/total-elevation/index.js
// module id = 1447
// module chunks = 0